// @flow strict
/* global VERSION, BUILD_NUMBER */

/** @fileoverview Utilities for Subscriptions */

import { createMuiTheme } from '@material-ui/core/styles'
import { sendGaEvent } from '../../util/tracker'
import { ThemeProvider } from '@material-ui/styles'
import * as React from 'react'
import Colors from '../../assets/colors.json'
import convert from 'convert-units'

// Types
import type { SOM } from '../../ducks/user/types'

/** Component ID to help with debugging */
export const COMPONENT_ID: 'SUBSCRIPTION' = 'SUBSCRIPTION'

/** Custom MUI theme */
const customTheme = {
  palette: {
    primary: {
      light: Colors.rachioBlue_tint_1,
      main: Colors.rachioBlue,
      dark: Colors.rachioBlue_shade_1,
      contrastText: Colors.white
    }
  },
  typography: {
    fontFamily: ['Avenir Next', 'Arial', 'sans-serif'].join(',')
  }
}

/** MUI Theme */
export const theme = createMuiTheme(customTheme)

/**
 * MUI Theme Provider
 * @param {object} props - Object containing component children
 * @return {JSX} - Component
 */
export const MuiThemeProvider = ({ children }: { children: React.Node }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
)

/**
 * Given square feet, convert to square meters if necessary
 * @param {number} sqFeet - Yard size in square feet
 * @param {string} som - System of measurement to convert to
 * @return {number} - `sqFeet` converted to square meter (if necessary)
 */
export const convertSqFeetToSqMetersIfNecessary = (
  sqFeet: number,
  som: SOM
): number =>
  som === 'METRIC'
    ? convert(sqFeet)
        .from('ft2')
        .to('m2')
    : sqFeet

/** Derive the current page withing the pgg funnel
 * @param {string} pathname - current pathname
 * @returns {string} - current page
 */
export const deriveCurrentPage = (pathname: string) => {
  switch (true) {
    case pathname.includes('/confirm-address'):
      return '/confirm-address'
    case pathname.includes('/max-size'):
      return '/max-size'
    case pathname.includes('/manual'):
      return '/manual'
    case pathname.includes('/yard-size'):
      return '/yard-size'
    case pathname.includes('/recommended-plan'):
      return '/recommended-plan'
    case pathname.includes('/purchase'):
      return '/purchase'
    case pathname.includes('/signup'):
      return '/signup'
    default:
      return pathname
  }
}

/** Send PGG Event to Google Analytics
 * @param {string} action - action to  be recorded in GA
 * @param {string} userId - user ID
 * @returns {Function} - GA handler function
 */
export const sendGaPggEvent = (action: string, userId: string) => {
  // @$FlowFixMe
  const label = `${userId}:${VERSION}-${BUILD_NUMBER}`
  const category = 'PGG-FLOW'

  return sendGaEvent({
    category,
    action,
    label
  })
}
